<template>
    <div class="upgrade-wrapper">
        <header>
            <div class="brand">
                <router-link :to="{ name: 'dashboard' }" title="Access to your Dashboard">
                    <svg-logo />
                </router-link>
            </div>
            <nav>
                <ul class="steps">
                    <li :class="{'is-done': $route.meta.steps > 1, 'active': $route.meta.steps === 1}">
                        <router-link v-if="$route.meta.steps > 1 && $route.meta.steps < 4" :to="{ name: 'upgrade' }"><svg-check /> Select your plan</router-link>
                        <span v-else>
                            <svg-check v-if="$route.meta.steps > 1" />
                            <svg-cross v-else />
                            Select your plan
                        </span>
                    </li>
                    <li :class="{'is-done': $route.meta.steps > 2, 'active': $route.meta.steps === 2}">
                        <router-link v-if="$route.meta.steps > 2 && $route.meta.steps < 4" :to="{ name: 'upgrade-settings', query: $route.query }"><svg-check /> Account informations</router-link>
                        <span v-else>
                            <svg-check v-if="$route.meta.steps > 2" />
                            <svg-cross v-else />
                            Account informations
                        </span>
                    </li>
                    <li :class="{'is-done': $route.meta.steps > 3, 'active': $route.meta.steps === 3}">
                        <span>
                            <svg-check v-if="$route.meta.steps > 3" />
                            <svg-cross v-else />
                            Payment details
                        </span>
                    </li>
                    <li :class="{'is-done': $route.meta.steps > 3, 'active': $route.meta.steps === 4}">
                        <span>
                            <svg-check v-if="$route.meta.steps > 3" />
                            <svg-cross v-else />
                            Payment success
                        </span>
                    </li>
                </ul>
            </nav>
            <div class="close">
                <router-link :to="{ name: 'dashboard' }">
                    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><line x1="18" y1="6" x2="6" y2="18"></line><line x1="6" y1="6" x2="18" y2="18"></line></svg>
                </router-link>
            </div>
        </header>
        <main id="upgrade-flow">
            <div v-if="plans.length === 0">
                <div class="alert" style="text-align: center">
                    Loading ...
                </div>
            </div>
            <template v-else>
                <router-view />
            </template>
        </main>
    </div>
</template>

<script>
import SvgLogo from '@/assets/images/logo.svg'
import SvgCheck from '@/assets/images/check.svg'
import SvgCross from '@/assets/images/cross.svg'

export default {
    components: { SvgLogo, SvgCheck, SvgCross },
    data () {
        return {
            plans: []
        }
    },
    computed: {
        selectedPlan () {
            if (this.$route.query.plan) {
                return this.plans.find(x => x.name === this.$route.query.plan)
            }
            return null
        }
    },
    watch: {
        plans (to) {
            if (!this.$route.query.plan) {
                return
            }

            if (!this.plans.find(x => x.name === this.$route.query.plan)) {
                this.$router.push({ name: 'upgrade' })
            }
        }
    },
    async created () {
        try {
            const response = await this.$http.get('credits/plans')
            this.plans = response.body.plans
        } catch (e) {
            alert('There was an error loading the plans. Please contact us and we will help you.')
        }
    }
}
</script>
